import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logoHeader from "../assets/logo-header.png";

import logoFooter from "../assets/logo-footer.png";
import logoFavicon from "../assets/favicon.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  return (
    <>
      {/* ======= Top Navbar (Unchanged) ======= */}
      <nav className="navbar">
        <div className="navbar-container">
          <div
            className="navbar-logo"
            onClick={() => (window.location.href = "/home")}
          >
            <img src={logoFavicon} alt="Logo" />
            <span className="navbar-title">
              GÖKÇE  <br /> CAPITAL  <br /> INVESTMENTS 
            </span>
          </div>

          <ul className="nav-links">
            <li  className="w3-hide">
              <NavLink to="/home" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Home
              </NavLink>
            </li>

            <li>
              <NavLink to="/aboutus" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Who we are
              </NavLink>
            </li>

            <li>
              <NavLink to="/services" className={({ isActive }) => (isActive ? "active-link" : "")}>
                What we do
              </NavLink>
            </li>

            <li className="">
              <NavLink to="/team" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Governance
              </NavLink>
            </li>
            <li>
              <NavLink to="/projects" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Portfolio
              </NavLink>
            </li>

            
            <li className="w3-hide">
              <NavLink to="/partners" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Partners
              </NavLink>
            </li>
            <li className="w3-hide">
              <NavLink to="/workwithus" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Work With Us
              </NavLink>
            </li>
            <li  className="w3-hide">
              <NavLink to="/contact" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Get in touch
              </NavLink>
            </li>
          </ul>

          {/* Hamburger Icon (for mobile) */}
          <div className="menu-icon w3-black " onClick={toggleSidebar}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
      </nav>

      {/* ======= Sidebar ======= */}
      <div
        className={`w3-sidebar w3-bar-block w3-black w3-animate-right w3-large ${
          isOpen ? "w3-show" : "w3-hide"
        }`}
        style={{
          width: "250px",
          right: 0,
          top: 0,
          height: "100%",
          position: "fixed",
          zIndex: 1201,
        }}
      >
        <button
          onClick={closeSidebar}
          className="w3-bar-item w3-button w3-large w3-right-align"
        >
          ✕
        </button>
        <NavLink to="/home" onClick={closeSidebar} className="w3-bar-item w3-button">Home</NavLink>

        <NavLink to="/services" onClick={closeSidebar} className="w3-bar-item w3-button">What we do</NavLink>

        <NavLink to="/aboutus" onClick={closeSidebar} className="w3-bar-item w3-button">Who we are</NavLink>

        <NavLink to="/team" onClick={closeSidebar} className="w3-bar-item w3-button">Governance</NavLink>

        <NavLink to="/projects" onClick={closeSidebar} className="w3-bar-item w3-button">Portfolio</NavLink>

        <NavLink to="/workwithus" onClick={closeSidebar} className="w3-hide w3-bar-item w3-button">Work With Us</NavLink>

        <NavLink to="/partners" onClick={closeSidebar} className="w3-bar-item w3-button w3-hide ">Portfolio</NavLink>

        <NavLink to="/contact" onClick={closeSidebar} className="w3-bar-item w3-button">Get in touch</NavLink>
      </div>

      {/* ======= Overlay ======= */}
      {isOpen && (
        <div
          className="sidebar-overlay"
          onClick={closeSidebar}
        ></div>
      )}
    </>
  );
}

export default Navbar;
